import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

// Components - imported
import { Avatar, Button } from '@material-ui/core';
import Alert from '../../../common/Alert';
import Logo from '../../../common/Logo';

// Icons
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const AddDescription = ({
    slideform3, 
    setSlideForm3,
    slideform2, 
    setSlideForm2,
    formData, 
    onChange,
    user,
    is_create_page
}) => {

    const [processing, setProcessing] = useState(false);

    // Toggle the value of slideform1 to go back to the previous form step
    const goBack = (e) => {
        setSlideForm2(!slideform2);
    }

    // Toggle the slideform1 state variable (go to next page in slide form)
    const todo = (e) => {
        setSlideForm3(!slideform3);
    }

    const { description } = formData;

    return (
        <div className="form-transition-element">

            {/* Back Button */}
            {!is_create_page && (
                <div onClick={goBack} className="form__backBtn">
                    <ArrowBackIcon />
                </div>
            )}

            {/* Display the heading */}
            <div>
                <h2>Add a description</h2>
            </div>

            {/* Header Description */}
            <div>
                <div style={{color:'rgb(83, 100, 113)', textAlign:'center', fontSize:'1rem', fontWeight:'500', marginTop:'5px', lineHeight:'20px', overflowWrap:'break-word'}}>
                    <span>Describe this group so people know what it's about.</span>
                </div>
            </div>

            {/* Input Box for Bio text */}
            <div className="modal__inputs" style={{flex:1, paddingLeft:'5px'}}>
                <textarea
                    style={{width:'94%', padding:'10px', minHeight:'100px', resize: 'none', fontSize: '16px'}}
                    type="text"
                    placeholder="Describe this group..."
                    className="input"
                    name="description"
                    value={description}
                    maxlength="160"
                    onChange={e => onChange(e)}
                />

                {/* Display Bio character length */}
                <div style={{color:'rgb(27, 149, 224)', display: 'flex', justifyContent: 'flex-end', width:'95%', fontSize:'14px', overflowWrap:'break-word'}}>
                    <span>{description && description.length} / 160</span>
                </div>
            </div>

            <Button 
                disabled={!description?.length > 0}
                onClick={todo}
                variant="outlined" 
                className={`sidebar__tweet ${description?.length > 0 ? 'black' : 'ghost'}`}
                fullWidth
            >
                Next
            </Button>

            <Button 
                onClick={goBack}
                variant="outlined" 
                className="sidebar__tweet heart"
                fullWidth
            >
                Go Back
            </Button>

            <div className="auth__footer">
                {/* <a href={`/register`}>Forgot password?</a>
                <a href={`/login`}>Log In</a> */}
            </div>
        </div>
    )
}

AddDescription.propTypes = {

}

export default AddDescription
